import React from 'react'
import FilterResultsGrid from './FilterResultsGrid'
import FilterResultsGridTrailer from './FilterResultsGridTrailer'
import FilterResultsList from './FilterResultsList'
import FilterResultsShowtimes from './FilterResultsShowtimes'

const OverviewViewSwitch = ({
    view,
    additionalScrollName,
    queryStringValues,
    isMobile,

    selectionId,
    activeSelection,

    activeItem,
    activeItemIndex,
    items,
    itemsData,

    interscrollerAdvertisements,
    interscrollerWeischerAds,
    
    activeFilters,
    dayFilters,

    programOverviewShowtimesType,
    hasGridHoverTrailer,
    theme,
    stripeAppearance,
    features,
    overviewFilterIgnoreOnPerformances,

    translation,
    moviesRoutesData,

    onOpenInformation,
    onCloseInformation,

    activeDetailsItem,
    onCloseDetails,
    onOpenDetails,
    onOpenDetailsFirstSidebar,
    onCloseDetailsFirstSidebar,

    activePerformance,
    performancePageOpen,
    onOpenPerformancePage,
    onClosePerformancePage,

    displaySidebarRight,
    displaySidebarRightSecond,
    onSidebarRightOpen,
    onSidebarRightClose,

    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    currentCinemaType,
    
    isConnectedFast
})  => {
    if('showtimes' === view) {
        return <FilterResultsShowtimes
            additionalScrollName={additionalScrollName}
            activeItem={activeItem}

            items={items}
            itemsData={itemsData}
            isMobile={isMobile}

            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            hideCinemaSelector={true}
            theme={theme}
            
            activeFilters={activeFilters}
            dayFilters={dayFilters}
            queryStringValues={queryStringValues}

            programOverviewShowtimesType={programOverviewShowtimesType}
            translation={translation}
            moviesRoutesData={moviesRoutesData}
            
            selectionId={selectionId}
            activeSelection={activeSelection}
            
            activePerformance={activePerformance}
            performancePageOpen={performancePageOpen}
            onOpenPerformancePage={onOpenPerformancePage}
            onClosePerformancePage={onClosePerformancePage}
            
            displaySidebarRightSecond={displaySidebarRightSecond}
            />
        } else if('list' === view)  {
            return <FilterResultsList 
            additionalScrollName={additionalScrollName}
            queryStringValues={queryStringValues}
            dayFilters={dayFilters}
            isSingleMovie={false}
            isMobile={isMobile}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}

            selectionId={selectionId}
            activeSelection={activeSelection}
            
            items={items}
            itemsData={itemsData}
            
            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            hideCinemaSelector={true}
            currentCinemaType={currentCinemaType}
            
            interscrollerAdvertisements={interscrollerAdvertisements}
            interscrollerWeischerAds={interscrollerWeischerAds} 
            
            theme={theme}
            stripeAppearance={stripeAppearance}

            translation={translation}
            moviesRoutesData={moviesRoutesData}

            activeDetailsItem={activeDetailsItem}
            onCloseDetails={onCloseDetailsFirstSidebar}
            onOpenDetails={onOpenDetailsFirstSidebar}

            activePerformance={activePerformance}
            performancePageOpen={performancePageOpen}
            onOpenPerformancePage={onOpenPerformancePage}
            onClosePerformancePage={onClosePerformancePage}

            onSidebarRightOpen={onSidebarRightOpen}
            onSidebarRightClose={onSidebarRightClose}
            displaySidebarRight={displaySidebarRight}
            displaySidebarRightSecond={displaySidebarRightSecond}
        />
    } else if('grid-trailer' === view) {
        return <FilterResultsGridTrailer
            trailerGrid={true}
            additionalScrollName={additionalScrollName}
            dayFilters={dayFilters}
            queryStringValues={queryStringValues}
            isMobile={isMobile}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}

            selectionId={selectionId}
            activeSelection={activeSelection}

            clusterCinemaActive={clusterCinemaActive}
            clusterCinemaOption={clusterCinemaOption}
            activeCinema={activeCinema}
            hideCinemaSelector={true}

            activeItem={activeItem}
            activeItemIndex={activeItemIndex}
            items={items}
            itemsData={itemsData}

            interscrollerAdvertisements={interscrollerAdvertisements}
            interscrollerWeischerAds={interscrollerWeischerAds}

            theme={theme}
            features={features}

            translation={translation}
            moviesRoutesData={moviesRoutesData}

            itemOnClick={onOpenInformation}
            closeItemInformation={onCloseInformation}

            activeDetailsItem={activeDetailsItem}
            closeItemDetails={onCloseDetails}
            openItemDetails={onOpenDetails}

            activePerformance={activePerformance}
            performancePageOpen={performancePageOpen}
            onOpenPerformancePage={onOpenPerformancePage}
            onClosePerformancePage={onClosePerformancePage}


            displaySidebarRight={displaySidebarRight}
            displaySidebarRightSecond={displaySidebarRightSecond}

            isConnectedFast={isConnectedFast}
        />
    } else if('grid'  === view) {
        return  <FilterResultsGrid
            additionalScrollName={additionalScrollName}
            dayFilters={dayFilters}
            queryStringValues={queryStringValues}
            isMobile={isMobile}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}

            selectionId={selectionId}
            activeSelection={activeSelection}

            activeItem={activeItem}
            activeItemIndex={activeItemIndex}
            items={items}
            itemsData={itemsData}

            interscrollerAdvertisements={interscrollerAdvertisements}
            interscrollerWeischerAds={interscrollerWeischerAds}

            hasGridHoverTrailer={hasGridHoverTrailer}
            theme={theme}
            stripeAppearance={stripeAppearance}

            translation={translation}
            moviesRoutesData={moviesRoutesData}

            itemOnClick={onOpenInformation}
            closeItemInformation={onCloseInformation}

            activeDetailsItem={activeDetailsItem}
            closeItemDetails={onCloseDetails}
            openItemDetails={onOpenDetails}

            activePerformance={activePerformance}
            performancePageOpen={performancePageOpen}
            onOpenPerformancePage={onOpenPerformancePage}
            onClosePerformancePage={onClosePerformancePage}


            displaySidebarRight={displaySidebarRight}
            displaySidebarRightSecond={displaySidebarRightSecond}

            isConnectedFast={isConnectedFast}
        />
    } else {
        return ''
    }
}

export default OverviewViewSwitch